module.exports = "/**\r\n * @license\r\n * Copyright Akveo. All Rights Reserved.\r\n * Licensed under the MIT License. See License.txt in the project root for license information.\r\n */\n:host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/framework/theme/components/card/card.component.scss
// module id = ./src/framework/theme/components/card/card.component.scss
// module chunks = main